import { gql } from 'apollo-boost'

const DELETE_SCRAPING_TAG = gql`
  mutation deleteScrapingTag($id: ID!) {
    deleteScrapingTag(id: $id)
  }
`

export default DELETE_SCRAPING_TAG
